import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const textOutlookWeb = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'outlook_text_web',
  type: 'TextOutlookWeb',
  className: 'outlook_text_web',
  associationType: 'TextOutlookWeb',
  minimumRequirements: 0,
  localizedText: {
    previewTypeStringKey: _TL_('Microsoft Outlook web (computer)'),
    stringKey: _TL_(''),
  },
  previewSettings: {
    showShortHeadline: true,
    showDescription: true,
    showBusinessName: true,
    showBusinessNameFirst: true,
    showAdsLabel: true,
    showPreHeadlineDivider: true,
    showPostHeadlineDivider: true,
  },
  styleOverrides: {
    previewContent: {
      border: '1px solid #C8C8C8',
      boxShadow: 'none',
      minWidth: 500,
      borderRadius: 0,
      marginTop: 150,
    },
    adsLabel: {
      backgroundColor: 'blue',
      borderRadius: 4,
      height: 13,
      verticalAlign: 'middle',
      padding: '0 4px',
      width: 'auto',
      display: 'inline-block',
      position: 'static',
      margin: '0 4px 0 0',
      fontSize: 10,
      color: 'white',
    },
    businessNameWithAds: {
      display: 'inline-block',
      color: 'black',
      textDecoration: 'none',
      marginTop: 0,
      marginRight: 40,
      verticalAlign: 'middle',
    },
    imageContainer: {
      display: 'inline-block',
    },
    textContainer: {
      display: 'inline-block',
    },
    preHeadlineDivider: {
      border: 'solid gray',
      display: 'inline-block',
      padding: '2px',
      transform: 'rotate(45deg) translateY(-3px)',
      borderWidth: '0 1.5px 1.5px 0',
      marginRight: 10,
    },
    shortHeadline: {
      display: 'inline-block',
      color: 'blue',
      padding: 4,
    },
    postHeadlineDivider: {
      display: 'inline-block',
      padding: 4,
      color: 'gray',
      '&:after': {
        content: '"*"',
      },
    },
    descriptionParent: {
      display: 'inline-block',
      color: 'black',
      textDecoration: 'none',
      padding: 4,
    },
    description: {
      display: 'inline-block',
    },
  },
};

export default textOutlookWeb;
